import { render, staticRenderFns } from "./PerguntasBase.vue?vue&type=template&id=a65d9d66&scoped=true"
import script from "./PerguntasBase.vue?vue&type=script&lang=js"
export * from "./PerguntasBase.vue?vue&type=script&lang=js"
import style0 from "./PerguntasBase.vue?vue&type=style&index=0&id=a65d9d66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a65d9d66",
  null
  
)

export default component.exports